import React from 'react'
import { CustomModal } from '../CustomModal/CustomModal'
import { t } from 'i18next'

const AdditionalVehicleInfo = ({ showModal, setShowModal, vehicle, statusColor, statusLabel }) => {

    return (
        <CustomModal
            title={t('ADDITIONAL_INFO')}
            showModal={showModal}
            setShowModal={setShowModal}
            centered={true}
        >
            <div className='d-flex justify-content-between'>
                <div>
                    <p className='vehicleName-card m-0'>{vehicle.vehicle_brand} {vehicle.vehicle_model} {vehicle.vehicle_year}</p>
                    <p className='vehiclePatent-card m-0'>{vehicle.vehicle_natural_id}</p>
                    <div className="d-flex gap-2">
                        {
                            vehicle.is_assigned ?
                                <p className='vehiclePatent-card m-0'>{t('ASSIGNED')}</p>
                                :
                                null
                        }
                        {
                            vehicle?.vehicle_status?.is_excepted === true ?
                                <p className='vehiclePatent-card m-0'>{t('EXCEPTED')}</p>
                                :
                                null
                        }
                    </div>
                    <div>
                        <p className='vehiclePatent-card m-0'>{t('CONTRACTOR')}:  <span className='vehicleContractorName-card m-0'>{vehicle.contractor_name ? vehicle.contractor_name : '-'}</span></p>
                    </div>
                </div>
                <div>
                    <h6
                        className='badge pe-4 ps-4'
                        style={{ background: statusColor }}
                    >
                        {statusLabel}
                    </h6>
                </div>
            </div>

            <hr />

            <div className='d-flex justify-content-between m-1'>
                <div>
                    <p className='m-0 text-description'>{t('CLASSIFICATION')}</p>
                    <p>{vehicle.classification_description ? vehicle.classification_description : '-'}</p>
                    <p className='m-0 text-description'>{t('COLOR')}</p>
                    <p>{vehicle.vehicle_color ? vehicle.vehicle_color : '-'}</p>
                </div>
                <div>
                    <p className='m-0 text-description'>{t('ENGINE_NUMBER')}</p>
                    <p>{vehicle.vehicle_motor ? vehicle.vehicle_motor : '-'}</p>
                    <p className='m-0 text-description'>{t('CHASSIS_NUMBER')}</p>
                    <p>{vehicle.vehicle_chassis ? vehicle.vehicle_chassis : '-'}</p>
                </div>

            </div>
        </CustomModal>
    )
}

export default AdditionalVehicleInfo